import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import MFCurrentForecastTracker from "./MFCurrentForecastTracker";
import MFPastForecastTracker from "./MFPastForecastTracker";
import { setActiveDataElement } from "../../../redux/userSlice";


const MFDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Market Forecast"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/bmf-dashboard"},
                { title: "Dashboard" },
              ]}
              title="Market Forecast Upload Dashboard"
            />
            <div class="container">
                {/* top table */}
             <MFCurrentForecastTracker />
             {/* bottom table */}
             <MFPastForecastTracker />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default MFDashboard

 